module.exports = __webpack_public_path__ + "static/img/indexLogo.0f42c2db.png";